import { MeterDto, Quadrant } from '@app/api/dmc';

/** Returns the meter register (A14, A23, R12, R34) mapped to the quadrant, if any. */
export function getRegisterForQuadrant(meter: MeterDto, quadrant: Quadrant): string | null {
  if (meter.mappingA14 === quadrant) return 'A14';
  if (meter.mappingA23 === quadrant) return 'A23';
  if (meter.mappingR12 === quadrant) return 'R12';
  if (meter.mappingR34 === quadrant) return 'R34';
  return null;
}
